var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPersonGrayR = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10 11.3335C10.8768 11.333 11.7398 11.4364 12.5898 11.6431C13.4403 11.8498 14.2802 12.1583 15.1094 12.5718C15.4265 12.7371 15.6802 12.9748 15.876 13.2935C16.07 13.6094 16.1664 13.9522 16.166 14.3325V15.0005C16.1659 15.3252 16.0564 15.5911 15.8232 15.8247C15.5905 16.0578 15.325 16.1669 15 16.1665H5C4.6752 16.1665 4.40976 16.0567 4.17676 15.8237C3.97284 15.6198 3.86236 15.391 3.83789 15.1187L3.83301 14.9995V14.3335C3.83301 13.9521 3.93001 13.6088 4.12402 13.2935C4.31961 12.9756 4.57335 12.7386 4.88965 12.5728C5.71876 12.1582 6.55887 11.8487 7.40918 11.6431C8.25952 11.4374 9.12281 11.334 10 11.3335ZM10 3.8335C10.7829 3.83357 11.4403 4.10682 12 4.6665C12.5597 5.22618 12.8329 5.88364 12.833 6.6665C12.833 7.44951 12.5598 8.10772 12 8.66748C11.4404 9.22705 10.7828 9.50041 10 9.50049C9.217 9.50049 8.55878 9.22724 7.99902 8.66748C7.43927 8.10772 7.16602 7.44951 7.16602 6.6665C7.16609 5.88372 7.43945 5.22615 7.99902 4.6665C8.55878 4.10675 9.217 3.8335 10 3.8335Z",
  stroke: "#171717",
  strokeOpacity: 0.5
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPersonGrayR);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/person-gray-r.59d77784416a8b1f890e5fca84266406.svg";